import _styled from "styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
// --> main component
export var Card = function Card(props) {
  var paddingType = props.paddingType,
      variant = props.variant,
      children = props.children,
      _props$className = props.className,
      className = _props$className === void 0 ? 'item' : _props$className,
      isActive = props.isActive,
      twStyle = props.twStyle,
      testId = props.testId;
  return /*#__PURE__*/_jsx(StyledCard, {
    isActive: isActive,
    className: className,
    paddingType: paddingType,
    variant: variant,
    twStyle: twStyle,
    "data-cy": testId,
    children: children
  });
};
export default Card;

var StyledCard = /*#__PURE__*/_styled.div.withConfig({
  displayName: "cardwrapper__StyledCard",
  componentId: "sc-68c9c6-0"
})(["", " ", " ", " ", ";", " ", " ", ""], {
  "height": "100%",
  "minHeight": "15rem",
  "width": "100%",
  "minWidth": "9rem"
}, {
  "position": "relative",
  "display": "flex",
  "flexDirection": "column",
  "gap": "1.5rem",
  "alignSelf": "center",
  "borderRadius": "1rem",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(229 231 235 / var(--tw-border-opacity))",
  "--tw-shadow": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
  "--tw-shadow-colored": "0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
}, function (_ref) {
  var _ref$paddingType = _ref.paddingType,
      paddingType = _ref$paddingType === void 0 ? 'base' : _ref$paddingType;
  return paddingTypeMap[paddingType];
}, function (_ref2) {
  var _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'gradientBase' : _ref2$variant;
  return variantBgMap[variant];
}, function (_ref3) {
  var isActive = _ref3.isActive;
  return isActive ? {
    "borderWidth": "2px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(105 62 181 / var(--tw-border-opacity))",
    "--tw-shadow": "var(--tw-shadow-colored)",
    "--tw-shadow-colored": "0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color)",
    "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)",
    "--tw-shadow-color": "rgb(105 62 181 / 0.3)"
  } : {};
}, function (_ref4) {
  var twStyle = _ref4.twStyle;
  return twStyle;
}, function (_ref5) {
  var noShadow = _ref5.noShadow;
  return noShadow ? {
    "--tw-shadow": "0 0 #0000",
    "--tw-shadow-colored": "0 0 #0000",
    "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
  } : {};
}); // --> other card components


export var CardTitle = /*#__PURE__*/_styled.div.withConfig({
  displayName: "cardwrapper__CardTitle",
  componentId: "sc-68c9c6-1"
})(["", " ", " ", ""], {
  "fontWeight": "600",
  "overflow": "hidden",
  "display": "-webkit-box",
  "WebkitBoxOrient": "vertical",
  "WebkitLineClamp": "3"
}, function (_ref6) {
  var _ref6$fontSize = _ref6.fontSize,
      fontSize = _ref6$fontSize === void 0 ? 'xLarge' : _ref6$fontSize;
  return fontSizeMap[fontSize];
}, function (_ref7) {
  var _ref7$textColor = _ref7.textColor,
      textColor = _ref7$textColor === void 0 ? 'white' : _ref7$textColor;
  return textColorMap[textColor];
});
export var CardSubTitle = /*#__PURE__*/_styled.span.withConfig({
  displayName: "cardwrapper__CardSubTitle",
  componentId: "sc-68c9c6-2"
})(["", " ", ""], {
  "width": "100%",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "400"
}, function (_ref8) {
  var _ref8$textColor = _ref8.textColor,
      textColor = _ref8$textColor === void 0 ? 'purple200' : _ref8$textColor;
  return textColorMap[textColor];
}); // --> constants

var fontSizeMap = {
  xLarge: {
    "fontSize": "1.875rem",
    "lineHeight": "2.25rem"
  },
  large: {
    "fontSize": "1.5rem",
    "lineHeight": "2rem"
  },
  medium: {
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem"
  },
  base: {
    "fontSize": "1rem",
    "lineHeight": "1.5rem"
  }
};
var textColorMap = {
  purple: {
    "--tw-text-opacity": "1",
    "color": "rgb(73 41 131 / var(--tw-text-opacity))"
  },
  purple200: {
    "--tw-text-opacity": "1",
    "color": "rgb(212 193 245 / var(--tw-text-opacity))"
  },
  white: {
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  },
  black: {
    "--tw-text-opacity": "1",
    "color": "rgb(28 19 39 / var(--tw-text-opacity))"
  },
  gray: {
    "--tw-text-opacity": "1",
    "color": "rgb(75 85 99 / var(--tw-text-opacity))"
  },
  gray300: {
    "--tw-text-opacity": "1",
    "color": "rgb(209 213 219 / var(--tw-text-opacity))"
  }
};
var variantBgMap = {
  primary50: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(246 245 255 / var(--tw-bg-opacity))"
  },
  primary100: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(226 216 243 / var(--tw-bg-opacity))"
  },
  gradientBase: {
    "backgroundImage": "linear-gradient(149.71deg, #673EAE 1.59%, #44257D 90.79%)"
  },
  white: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
  },
  gray100: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(243 244 246 / var(--tw-bg-opacity))"
  },
  gray50: {
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(209 213 219 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(249 250 251 / var(--tw-bg-opacity))"
  }
};
var paddingTypeMap = {
  base: {
    "padding": "1rem"
  },
  large: {
    "padding": "1.75rem"
  }
}; // --> types